
import { Text } from "@chakra-ui/react"

import { IIConStyles, IIConProps } from "./IconTypes"
import { StyledIcon } from "./StyledIcon"

// Dashboard Icons
import { ReactComponent as PeopleIcon } from "assets/icons/group.svg"
import { ReactComponent as WarehouseIcon } from "assets/icons/warehouse.svg"
import { ReactComponent as SettingsIcon } from "assets/icons/settings.svg"
import { ReactComponent as TrendingUpIcon } from "assets/icons/trending_up.svg"
import { ReactComponent as PersonIcon } from "assets/icons/person.svg"
import { ReactComponent as QappIcon } from "assets/icons/qapp-logo.svg"
import { ReactComponent as CurrencyExchange } from "assets/icons/currency_exchange.svg"
import { ReactComponent as AddPerson } from "assets/icons/personAdd.svg"
import { ReactComponent as ThreeDots } from "assets/icons/dots.svg"
import { ReactComponent as Lock } from "assets/icons/lock.svg"

//Laundry Icons
import { ReactComponent as FullWash } from "assets/icons/fullwash.svg"
import { ReactComponent as Done } from "assets/icons/done.svg"
import { ReactComponent as DeleteForever } from "assets/icons/delete_forever.svg"
import { ReactComponent as CalendarMonth } from "assets/icons/calendar_month.svg"
import { ReactComponent as Print } from "assets/icons/print.svg"
import { ReactComponent as RedClose } from "assets/icons/red-close.svg"
import { ReactComponent as OnlyBody } from "assets/icons/onlybody.svg"
import { ReactComponent as Salon } from "assets/icons/salon.svg"
import { ReactComponent as Coupe } from "assets/icons/coupe.svg"
import { ReactComponent as HatchBack } from "assets/icons/hatchback.svg"
import { ReactComponent as Minivan } from "assets/icons/minivan.svg"
import { ReactComponent as Jeep } from "assets/icons/jeep.svg"
import { ReactComponent as Sedan } from "assets/icons/sedan.svg"
import { ReactComponent as BlackTires } from "assets/icons/black-tires.svg"
import { ReactComponent as EngineWash } from "assets/icons/engineWash.svg"
import { ReactComponent as Polish } from "assets/icons/polish.svg"
import { ReactComponent as steamWashing } from "assets/icons/steamWashing.svg"
import { MdLocationOn } from "react-icons/md"

// Actions Icons
import { MdClose } from "react-icons/md"
import { IoMdCheckmark } from "react-icons/io"
import { IoIosCheckmarkCircleOutline } from "react-icons/io"
import { MdEdit } from "react-icons/md"
import { IoIosAddCircle } from "react-icons/io"
import { IoCaretDown } from "react-icons/io5"
import { AiFillCheckCircle } from "react-icons/ai"
import { BsCalendarRange } from "react-icons/bs"
import { MdDelete } from "react-icons/md"
import { AiFillCloseCircle } from "react-icons/ai"
import { MdSearch } from "react-icons/md"
import { RiErrorWarningLine } from "react-icons/ri"
import { IoKeySharp } from "react-icons/io5";


// Input icons
import { BiImages } from "react-icons/bi"
import { RiInformationLine } from "react-icons/ri"

// Bookings Icons
import { IoPlaySharp } from "react-icons/io5"
import { IoStopSharp } from "react-icons/io5"
import { AiFillEye } from "react-icons/ai"
import { WiMoonAltWaningCrescent2 } from "react-icons/wi"
import { IoMdCall } from "react-icons/io"
import { BsFillBellFill } from "react-icons/bs"

// loundries page 
import { IoMdEye } from "react-icons/io"
import { BiCalendarX } from "react-icons/bi"
import { FiPercent } from "react-icons/fi"
import { MdOutlineSettingsBackupRestore } from "react-icons/md"
import { BsCheck2 } from "react-icons/bs"

/// Settings Page
import { ReactComponent as BookingSettings } from "assets/icons/order-settings.svg"
import { ReactComponent as CancellaitonFee } from "assets/icons/cancel-comision.svg"
import { FaPercent } from "react-icons/fa"
import { ReactComponent as QappPremium } from "assets/icons/qapp-premium.svg"
import { ReactComponent as newQapp } from "assets/icons/new-qapp.svg"
import { ReactComponent as DashboardQapp } from "assets/icons/dashboard-qapp.svg"

// Customers Page
import { HiLockClosed } from "react-icons/hi"
import { FaCarSide } from "react-icons/fa"

// Transaction Statuses
import { BsThreeDots } from "react-icons/bs"

// Arrows
import { MdKeyboardArrowLeft } from "react-icons/md"
import { MdKeyboardArrowDown } from "react-icons/md"
import { AiOutlineDoubleLeft } from 'react-icons/ai'
import { AiOutlineDoubleRight } from 'react-icons/ai'

//Extract Reports Page
import { GrDocument } from "react-icons/gr"
import { MdDownloadForOffline } from "react-icons/md"
import { MdKeyboardArrowRight } from "react-icons/md"
import { MdLocationCity } from "react-icons/md"
import { FaFileCsv } from 'react-icons/fa'

const NoIcon = () => <></>

const getIcon = (name: string) => {
  switch (name) {
    case "users":
      return PeopleIcon
    case "warehouse":
      return WarehouseIcon
    case "settings":
      return SettingsIcon
    case "trending_up":
      return TrendingUpIcon
    case "user":
      return PersonIcon
    case "qapp_logo":
      return QappIcon
    case "currency_exchange":
      return CurrencyExchange
    case "doneIcon":
      return Done
    case "delete_forever":
      return DeleteForever
    case "calendar_month":
      return CalendarMonth
    case "print":
      return Print
    case "red-close":
      return RedClose
    case "edit":
      return MdEdit
    case "close":
      return MdClose
    case "close_rounded":
      return AiFillCloseCircle
    case "checkmark":
      return IoMdCheckmark
    case "checkmark_outline":
      return IoIosCheckmarkCircleOutline
    case "add_circle":
      return IoIosAddCircle
    case "add_person":
      return AddPerson
    case "dots":
      return ThreeDots
    case "lock":
      return Lock
    case "delete":
      return MdDelete
    case "dropdown":
      return IoCaretDown
    case "confirm":
      return AiFillCheckCircle
    case "calendar":
      return BsCalendarRange
    case "search":
      return MdSearch
    case "key":
      return IoKeySharp
    case "picture":
      return BiImages
    case "info":
      return RiInformationLine
    case "full_wash":
      return FullWash
    case "only_body":
      return OnlyBody
    case "salon":
      return Salon
    case "coupe":
      return Coupe
    case "hatchBack":
      return HatchBack
    case "minivan":
      return Minivan
    case "jeep":
      return Jeep
    case "sedan":
      return Sedan
    case "blackTires":
      return BlackTires
    case "engineWash":
      return EngineWash
    case "polish":
      return Polish
    case "steamWashing":
      return steamWashing
    case "location":
      return MdLocationOn
    case "play":
      return IoPlaySharp
    case "stop":
      return IoStopSharp
    case "view":
      return AiFillEye
    case "moon":
      return WiMoonAltWaningCrescent2
    case "call":
      return IoMdCall
    case "bell":
      return BsFillBellFill
    case "arrowLeft":
      return MdKeyboardArrowLeft
    case "arrowDown":
      return MdKeyboardArrowDown
    case "eye":
      return IoMdEye
    case "bookingsSettings":
      return BookingSettings
    case "cancellationFee":
      return CancellaitonFee
    case "bookingFee":
      return FaPercent
    case "qappPremium":
      return QappPremium
    case "filledLock":
      return HiLockClosed
    case "car":
      return FaCarSide
    case "dots_horz":
      return BsThreeDots
    case "warning":
      return RiErrorWarningLine
    case "calendarX":
      return BiCalendarX
    case "percent":
      return FiPercent
    case "outlinedSetting":
      return MdOutlineSettingsBackupRestore
    case "checkIcon":
      return BsCheck2
    case "document":
      return GrDocument
    case "download":
      return MdDownloadForOffline
    case "arrowRight":
      return MdKeyboardArrowRight
    case "district":
      return MdLocationCity
    case "double_arrow_left":
      return AiOutlineDoubleLeft
    case "double_arrow_right":
      return AiOutlineDoubleRight
    case "file_csv":
      return FaFileCsv
    case "new_qapp":
      return newQapp
    case "dashboard_qapp":
      return DashboardQapp
    default:
      return NoIcon
  }
}

interface IIconHOCProps {
  comp: React.ElementType
  styles?: IIConStyles
}

const DEFAULT_ICON_STYLES = {
  fill: "#fff",
  width: "16px",
  height: "16px",
  pointerEvents: "auto",
  opacity: 1
}

const IconHOC = ({ comp, styles }: IIconHOCProps) => {
  const Comp = comp

  return <Comp {...styles} className="icon" />
}

const Icon: React.FC<IIConProps> = ({
  name,
  iconStyles = DEFAULT_ICON_STYLES,
  renderContent,
  content
}) => {
  return (
    <>
      {renderContent ?
        (
          <Text color="primary">{content}</Text>
        )
        : (
          <StyledIcon {...iconStyles}>
            <IconHOC comp={getIcon(name)} styles={iconStyles} />
          </StyledIcon>
        )
      }
    </>
  )
}

export default Icon
